import { render, staticRenderFns } from "./NarliFerryboatStatsByVehicleTypeGraph.vue?vue&type=template&id=7f3dffa6&"
import script from "./NarliFerryboatStatsByVehicleTypeGraph.vue?vue&type=script&lang=js&"
export * from "./NarliFerryboatStatsByVehicleTypeGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports